import { setContext } from '@apollo/client/link/context';

import { getSubscriptionId } from '@/utils/auth/subscription.utils';
import { getAccessToken } from '@/utils/auth/token.utils';

type HeadersType = {
  subscriptionid?: string;
  Authorization?: string;
};

export const headersLink = setContext(async () => {
  const headers: HeadersType = {};
  const subscriptionId = await getSubscriptionId();
  const accessToken = await getAccessToken();

  if (subscriptionId) {
    headers.subscriptionid = subscriptionId;
  }

  if (accessToken) {
    headers.Authorization = `Bearer ${accessToken}`;
  }

  return { headers };
});
